<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <label class="mb-0" style="font-weight: 500;">
      {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
    <input class="field_submit" type="time" maxlength="200" [value]="formGroup.get(fieldKey)?.value" (change)="onTimeChange($event)" [formControlName]="fieldKey" />
  </div>
</div>